export const useGlobalMixin = function (Vue) {
  Vue.mixin({
    data: function () {
      return {
        is_mobile: this.checkIfIsMobile(),
        toggle_off_nivel_meta: true
      };
    },
    methods: {
      checkIfIsMobile() {
        return !!(navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/BlackBerry/i));
      }
    }
  });
};
